export default __webpack_public_path__ + "static/media/clear-all-icon.379473f9.svg";